import { Rule } from './rule';

export class BlocksCheatSheet {
  public static readonly allCheatSheets: Rule[] = [
    {
      title: 'components.cheat-sheet.blocks.header-1',
      body: [
        {
          type: 'text',
          content: 'components.cheat-sheet.blocks.body-1',
        },
      ],
    },
    {
      title: 'components.cheat-sheet.blocks.header-2',
      body: [
        {
          type: 'text',
          content: 'components.cheat-sheet.blocks.body-2a',
        },
      ],
    },
    {
      title: 'components.cheat-sheet.blocks.header-3',
      body: [
        { type: 'text', content: 'components.cheat-sheet.blocks.body-3a' },
        { type: 'text', content: 'components.cheat-sheet.blocks.body-3b' },
        { type: 'text', content: 'components.cheat-sheet.blocks.body-3c' },
      ],
    },
    {
      title: 'components.cheat-sheet.blocks.header-4',
      body: [
        { type: 'text', content: 'components.cheat-sheet.blocks.body-4a' },
        { type: 'text', content: 'components.cheat-sheet.blocks.body-4b' },
        { type: 'text', content: 'components.cheat-sheet.blocks.body-4c' },
        { type: 'text', content: 'components.cheat-sheet.blocks.body-4d' },
      ],
    },
    {
      title: 'components.cheat-sheet.blocks.header-5',
      body: [
        { type: 'text', content: 'components.cheat-sheet.blocks.body-5a' },
        { type: 'text', content: 'components.cheat-sheet.blocks.body-5b' },
      ],
    },
    {
      title: '',
      body: [
        {
          type: 'text',
          content: 'components.cheat-sheet.blocks.body-6a',
        },
      ],
    },
  ];
}
